import { useEffect, useState } from "react";
import { Typography, Grid, CircularProgress } from "@mui/material";
import Report from "./Report";
import SectionHeader from "./SectionHeader";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import KeyboardArrowUpOutlinedIcon from "@mui/icons-material/KeyboardArrowUpOutlined";

const Section = ({
  type,
  sectionName,
  sectionReports,
  hasMore = true,
  limit = 2,
  isCorzapReports = false,
  loading,
}) => {
  const sortedReportsByDate = sectionReports.sort((a, b) => {
    return new Date(b.creationDate) - new Date(a.creationDate);
  });
  const [showAll, setShowAll] = useState(false);
  const [reports, setReports] = useState(sortedReportsByDate.slice(0, limit));

  useEffect(() => {
    if (showAll) setReports(sectionReports);
    else setReports(sectionReports.slice(0, limit));
  }, [showAll, sectionReports, limit]);

  return (
    <div>
      <SectionHeader headline={sectionName} />
      <Grid container direction="column" spacing={1}>
        {!loading ? (
          reports.map((report) => {
            return (
              <Grid key={report.reportName} item xs={12}>
                <Report type={type} report={report} isCorzapReports />
              </Grid>
            );
          })
        ) : (
          <CircularProgress
            sx={{
              marginRight: "auto",
              marginLeft: "auto",
            }}
          />
        )}
      </Grid>

      {hasMore && (
        <Typography
          sx={{
            display: "flex",
            color: "#007AFF",
            fontSize: ".875rem",
            lineHeight: "16px",
            cursor: "pointer",
            textDecoration: "underline",
            textDecorationColor: "#007AFF",
            marginTop: "10px",
          }}
          onClick={() => setShowAll(!showAll)}
        >
          {!showAll
            ? !isCorzapReports
              ? "Show all saved reports"
              : "Show all system reports"
            : !isCorzapReports
            ? "Hide saved reports"
            : "Hide system reports"}

          {!showAll ? (
            <KeyboardArrowDownOutlinedIcon sx={{ fontSize: "1rem" }} />
          ) : (
            <KeyboardArrowUpOutlinedIcon sx={{ fontSize: "1rem" }} />
          )}
        </Typography>
      )}
    </div>
  );
};

export default Section;
